export const MALL_BONUS_ID_URL_SECTION = ':id';

export const STEP_URL_SECTION = ':step';

export const STEP_ROUTE_PATH = `/mallBonuses/${MALL_BONUS_ID_URL_SECTION}/step/${STEP_URL_SECTION}`;

export const NEW_MALL_BONUS_ROUTE_PATH = `/mallBonuses/new`;
